<template>
  <div class="accordion-group">
    <div class="accordion-heading">
      <a class="accordion-toggle" data-toggle="collapse" data-parent="#collapse-alert" href="#collapseSomministrations">
        <i class="fa-light fa-suitcase-medical"></i>
        ALERT SOMMINISTRAZIONI NON ESEGUITE
      </a>
    </div>
    <div id="collapseSomministrations" :class="['accordion-body', 'collapse', { in: isActive }]">
      <div class="accordion-inner well well-large alert-controller-welcome" id="not-somministrations">
        <div class="row-fluid" v-if="Object.keys(itemSomministrations).length > 0">
          NELLE ULTIME {{ hoursNotAdministered }} ORE NON SONO STATE ESEGUITE QUESTE SOMMINISTRAZIONI:
        </div>
        <div class="row-fluid">
          <template v-for="(hours, date) in itemSomministrations">
            <div :key="date" class="span6" v-if="Object.keys(hours).length > 0">
              <dl>
                <dt><fa-icon :icon-name="'fa-calendar-days'" /> {{ date }}</dt>
                <dd>
                  <ul class="unstyled">
                    <li v-for="(values, hour) in hours" :key="hour">
                      <a :href="`${linkSomministrations.replace('__TIME_ID__', hour)}?date=${date}`" target="_blank">
                        <div class="row-fluid">
                          <div class="span6 left-align"><fa-icon :icon-name="'fa-clock'" /> {{ values.desc }}</div>
                          <div class="span6 left-align"><fa-icon :icon-name="'fa-pills'" /> {{ values.tot }}</div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </dd>
              </dl>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import apiConnector from '@/epersonam/apiConnector';
import FaIcon from '../faIcon';
export default {
  name: 'alertSomministration',
  components: { FaIcon },
  props: ['urlAlertTherapy', 'linkSomministrations', 'isActive', 'hoursNotAdministered'],
  data() {
    return {
      itemSomministrations: {},
    };
  },
  mounted() {
    if (this.isActive) {
      this.loadElements();
    }
    $('#collapseSomministrations').on('shown', () => {
      if (Object.keys(this.itemSomministrations).length === 0) {
        this.loadElements();
      }
    });
  },
  methods: {
    loadElements() {
      $('#not-somministrations').addClass('loader-without-modal');
      apiConnector()
        .get(this.urlAlertTherapy)
        .then(({ data }) => {
          if (!data) {
            setTimeout(this.loadElements, 3000);
            return;
          }

          this.addElementsInMessage(data);
        })
        .catch((err) => {
          $('#not-somministrations').removeClass('loader-without-modal');
        });
    },
    addElementsInMessage(elements) {
      var records = [],
        lim_inf = moment().subtract(this.hoursNotAdministered, 'hours'),
        lim_sup = moment();
      this.itemSomministrations = {};
      // [['2019-01-01', '12:00', 1, 'pranzo', 23], ['2019-01-01', '14:00', 2, 'merenda', 2], ...]
      $.each(elements.split('|'), (i, v) => {
        var result = v.split(';'),
          date_time;
        date_time = moment(result[0] + ' ' + result[1]);
        if (date_time <= lim_sup && date_time >= lim_inf) {
          records.push(result);
        }
      });
      records.sort((r1, r2) => moment(r1[0] + ' ' + r1[1]) - moment(r2[0] + ' ' + r2[1]));
      // { '2019-01-01' => { 1 => { tot => 23, desc => 'pranzo' }, 2 => { tot => 2, desc => 'merenda' }, ..}, ..},
      $.each(records, (i, r) => {
        var date = moment(r[0]).format(window.i18nJS.time.formats.date_only);
        if (!this.itemSomministrations[date]) {
          this.itemSomministrations[date] = {};
        }
        this.itemSomministrations[date][r[2]] = { tot: r[4], desc: r[3] };
      });
      $('#not-somministrations').removeClass('loader-without-modal');
    },
  },
};
</script>
<style lang="scss" scoped>
.alert-controller-welcome {
  text-align: left;
  min-height: 180px;
  max-height: 350px;
  overflow-y: scroll;
}
.left-align {
  text-align: left;
}
</style>
